import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from "lodash";

require('./bringoz-capacity.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-capacity',
  templateUrl: './bringoz-capacity.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCapacityComponent implements OnInit {

  @Input() value: number;
  @Input() weight: any;
  @Input() volume: any;
  @Input() packages: any;
  @Input() totalWeight: any;
  @Input() totalVolume: any;
  @Input() totalPackages: any;
  @Input() spots: any;
  @Input() totalSpots: any;
  @Input() pallets: any;
  @Input() totalPallets: any;
  @Input() showPackages: string;
  @Input() isLayoutRow: any;

  public weightUnit: any;
  public volumeUnit: any;
  public labelsMap: any;

  constructor(@Inject('splitService') private splitService) {}

  ngOnInit() {
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();

    this.labelsMap = {};
    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
  }


}
